import React from 'react';
import moment from 'moment';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import useFlashOnView from '../../../util/useFlashOnView';
import { colors } from '../../../theme/tokens';

/* One cycle chat message. All messages read top-down on the left; the other side's are indented one
   step and grey, own ones are in the primary tint. `highlight` flashes it once when it scrolls into view. */
const ChatMessage = ({ own, time, name, avatarUrl, text, highlight = false }) => {
  const { ref, flashClassName } = useFlashOnView(highlight);

  return (
    <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-start', my: 1.25, ml: own ? 0 : 6 }}>
      <Avatar src={avatarUrl || undefined} alt={name} sx={{ width: 32, height: 32, mt: 0.5 }} />
      <Box
        ref={ref}
        className={flashClassName}
        sx={{ flex: 1, minWidth: 0, borderRadius: 2.5, px: 1.75, py: 1.25, backgroundColor: own ? colors.primaryTint : '#f1f4f9' }}
      >
        <Typography sx={{ fontSize: 11, color: colors.textGrey, mb: 0.5 }}>
          {own ? 'You' : name} · {moment(time).format('DD MMM YYYY, HH:mm')}
        </Typography>
        <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
          {text}
        </Typography>
      </Box>
    </Box>
  );
};

export default ChatMessage;
